var _g, _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConsistancyChamp(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 111,
    height: 111,
    viewBox: "0 0 111 111",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7938_60607)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M120.024 2H-31.6289V108.986H120.024V2Z",
    fill: "url(#paint0_radial_7938_60607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.024 40.501L101.399 45.1076L72.4936 54.2788L61.7834 65.4388L45.3512 72.9936L31.4374 83.179L19.7961 84.3811L5.81345 90.9295L-3.54905 91.7835C-3.54905 91.7835 -26.1452 99.614 -31.6289 101.35V108.987H120.024V40.501Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.399 45.1075L73.4986 53.9598L72.4936 54.2787L61.7834 65.4387L45.3512 72.9935L31.4374 83.1789L19.7961 84.381L5.81345 90.9294L-3.54905 91.7834C-3.54905 91.7834 -26.1452 99.6139 -31.6289 101.35V105.612L-8.51691 103.129L10.1597 96.564L16.6701 89.2227L34.4729 85.925L50.1395 74.7447L69.5536 75.9189L85.0941 62.9416L104.401 54.28L111.853 46.9882L120.026 44.9372V40.5034L101.399 45.1075Z",
    fill: "url(#paint1_linear_7938_60607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.7752 23.0035L44.0391 39.0154L47.8363 52.5378L53.8245 63.8948L71.5865 66.0793L90.2758 57.8789L99.9504 45.7633L100.198 37.2999L98.6078 28.7068L89.979 17.1147L74.2449 10.4495L57.7096 13.4955L46.7752 23.0035Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.9518 34.808L88.4042 41.8278L81.7804 40.0296L72.8905 42.3297L72.1173 54.6538L56.8265 59.0596L47.8359 52.538L53.8241 63.8949L68.8614 60.23H82.1626L95.5312 44.8484L96.9477 37.4309L96.3745 28.5875L93.2625 23.0037L90.9518 34.808Z",
    fill: "url(#paint2_linear_7938_60607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.3828 71.9287V69.7341L43.3165 69.166L45.0145 68.7937L45.6947 70.3619L45.0999 71.9287H42.3828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M101.109 43.791L101.874 43.092L102.574 43.4415V44.1722L101.842 44.7441L101.109 43.791Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M102.225 48.9937L101.492 49.8832L101.859 50.2644H102.702L102.957 49.629L102.225 48.9937Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.07812 88.839L4.71503 87.4412H5.67039L6.37098 88.839L5.67039 89.3384L4.07812 88.839Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.8906 65.1261L43.5275 63.7283H44.4829L45.1835 65.1261L44.4829 65.6243L42.8906 65.1261Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M55.7227 65.9521L56.4869 65.2532L57.1875 65.6026V66.3333L56.4551 66.9052L55.7227 65.9521Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.57399 85.1259C9.69373 84.9911 9.83385 84.7573 9.9625 84.5159C9.8606 84.399 9.7727 84.2744 9.70392 84.1423L17.022 73.6507L19.6524 66.0234C19.6524 66.0234 19.6536 65.4262 19.7339 64.623C18.9288 63.6826 18.348 62.7995 18.348 62.7995C18.348 62.7995 22.707 59.2692 23.5413 58.4318C23.5566 58.4165 23.5719 58.4013 23.5872 58.3848C24.5056 57.4228 28.3474 52.3892 28.3474 52.3892C29.8823 50.0611 31.365 48.2782 32.151 48.0444C33.0337 47.7813 34.2502 47.4967 34.2502 47.4967L35.0056 47.0964C35.0056 47.0964 35.0527 47.1472 35.1304 47.2298C35.3533 46.8587 35.5992 46.4051 35.7355 45.9781C36.0883 44.8776 36.2208 42.2661 36.6093 41.7502C36.9978 41.2343 41.2269 41.9027 41.2269 41.9027C41.0511 42.1924 40.553 42.4072 40.553 42.4072C40.553 42.4072 40.3492 48.4294 39.9531 48.5425C39.5225 48.6658 38.306 48.4574 38.306 48.4574L37.6488 49.6278C39.3977 49.8235 42.1963 50.1018 42.1963 50.1018L47.9666 48.7853L48.0405 48.8793L48.4991 48.7611C48.4991 48.7611 48.5207 48.8056 48.5564 48.8831C49.0366 48.7217 49.5308 48.5286 49.6162 48.3913C49.7385 48.1943 49.4328 47.212 49.6251 46.5144C49.671 46.3504 50.3079 46.0404 50.3079 46.0404L50.741 46.1039L50.8187 46.4089C50.8709 46.2767 50.9206 46.1687 50.9626 46.1014C51.2034 45.7227 52.402 45.2296 52.9931 45.2919C54.058 45.405 52.5243 46.1763 52.5243 46.1763C52.5243 46.1763 53.0771 47.6987 52.9765 48.0914C52.8746 48.4853 52.667 48.9454 51.9524 49.6367C51.7205 49.8616 50.7499 50.4716 49.9678 50.9252C49.969 51.0803 49.9487 51.2213 49.899 51.3357L49.4837 51.4437C49.4646 51.6852 49.4022 51.9165 49.2786 52.1236C49.2786 52.1236 42.7593 53.5609 42.0625 53.6231C41.3657 53.6854 37.557 53.9281 37.557 53.9281C37.557 53.9281 37.0819 56.795 35.3801 58.0836C33.6783 59.3721 31.7001 60.9022 30.5447 62.1793C30.5447 62.1793 37.0641 65.8455 37.7901 66.8088C38.5162 67.772 36.3036 78.3068 36.3036 78.3068C36.3036 78.3068 35.4845 78.4911 34.5356 78.5597C34.6196 78.9041 34.7661 79.2879 35.0094 79.4543C35.4973 79.7886 37.6844 80.18 38.2194 80.0808C38.7544 79.9817 39.078 80.2181 39.0385 80.5282C38.999 80.8382 36.0578 81.7812 35.4654 81.6642C34.8744 81.5473 34.0286 81.6871 34.0286 81.6871L34.0388 82.034L32.1854 82.3047C31.9523 81.5257 31.8822 80.1037 32.0542 79.7288C32.1523 79.5166 32.286 78.8736 32.3828 78.3564C32.2975 78.3208 32.216 78.2801 32.1433 78.2331L33.5407 69.1305L25.9679 66.5216C25.9679 66.5216 20.7313 75.0956 20.353 75.6001C19.9759 76.1046 13.1967 86.0611 13.1967 86.0611C13.1967 86.0611 12.6668 85.962 12.0095 85.732C12.0197 85.7714 12.0286 85.8057 12.035 85.8299C12.0898 86.0395 12.9636 87.5187 13.7801 87.6255C14.5966 87.7322 16.0335 88.1287 15.3584 88.5659C14.6832 89.003 11.8235 89.2762 11.3115 88.7539C10.7994 88.2304 10.1803 88.036 10.1803 88.036L9.85041 88.1211C9.30012 87.9546 8.625 87.2023 8.625 87.2023C8.75493 86.6317 9.24662 85.4918 9.57399 85.1259Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5541 53.9269L36.1771 53.9053C36.1771 53.9053 35.8459 55.1189 35.4918 56.3096C35.3236 56.8764 34.8205 57.9146 34.418 58.8143C34.7428 58.564 35.0638 58.3187 35.3771 58.0823C37.079 56.7938 37.5541 53.9269 37.5541 53.9269Z",
    fill: "#FFF0B5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.5708 56.0415C35.9656 55.3438 36.3261 54.5966 36.5376 53.9104L37.2446 53.9218C37.1235 54.5318 36.9337 55.4658 36.749 56.3325C36.4217 56.9819 35.9758 57.63 35.3771 58.0824C35.0651 58.3188 34.7428 58.564 34.418 58.8144C34.8205 57.9146 35.3224 56.8764 35.4918 56.3096C35.5185 56.2207 35.544 56.1305 35.5708 56.0415Z",
    fill: "url(#paint3_linear_7938_60607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6685 42.1314C37.7603 42.0628 36.9234 42.2255 36.3477 42.5177C36.4228 42.1632 36.5056 41.8849 36.6075 41.7502C36.996 41.2343 41.2251 41.9027 41.2251 41.9027C41.2251 41.9027 40.285 42.2547 38.6685 42.1314Z",
    fill: "url(#paint4_linear_7938_60607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1247 62.9596C19.1247 62.9596 19.5947 64.0233 20.773 64.9827C21.7271 65.7592 23.3703 66.4772 23.3703 66.4772C23.3703 66.4772 21.2583 66.1048 19.7336 64.6231C18.9285 63.6827 18.3477 62.7995 18.3477 62.7995C18.3477 62.7995 22.7066 59.2693 23.541 58.4318C23.5563 58.4166 23.5715 58.4013 23.5868 58.3848C24.5053 57.4228 28.3471 52.3892 28.3471 52.3892C29.882 50.0612 31.3647 48.2783 32.1507 48.0444C33.0334 47.7814 34.2499 47.4967 34.2499 47.4967L35.0053 47.0964C35.0053 47.0964 35.0524 47.1473 35.1301 47.2299L36.3784 48.5184L34.9352 47.6047C34.9352 47.6047 34.2091 47.9453 33.692 48.1131C33.1748 48.2808 31.6985 48.4778 30.7304 49.8464C29.7635 51.2163 25.4097 57.4432 23.8696 58.9605C22.327 60.4803 19.1247 62.9596 19.1247 62.9596Z",
    fill: "url(#paint5_linear_7938_60607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.3235 69.034C34.3885 69.1077 32.9312 78.4797 32.9312 78.4797C32.9312 78.4797 32.7669 78.5229 32.3758 78.3552C32.2905 78.3196 32.209 78.2789 32.1364 78.2319L33.5337 69.1293L25.9609 66.5204L26.7596 65.3716C26.7583 65.3729 34.2598 68.9603 34.3235 69.034Z",
    fill: "url(#paint6_linear_7938_60607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.688 48.3214C39.7555 48.2541 39.3403 42.5546 39.3403 42.5546C40.0906 42.566 40.5529 42.4084 40.5529 42.4084C40.5529 42.4084 40.3491 48.4307 39.953 48.5438C39.697 48.6162 39.1645 48.573 38.7734 48.526C39.1428 48.4599 39.646 48.3646 39.688 48.3214Z",
    fill: "url(#paint7_linear_7938_60607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.049 79.7289C32.1471 79.5167 32.2808 78.8737 32.3776 78.3564C32.7687 78.5229 32.933 78.481 32.933 78.481C32.933 78.481 32.4948 79.5599 32.4375 79.903C32.3878 80.1978 32.4209 81.5563 32.5802 82.2476L32.1802 82.306C31.9458 81.5245 31.877 80.1038 32.049 79.7289Z",
    fill: "url(#paint8_linear_7938_60607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.70312 84.1423L17.0212 73.6507L19.6516 66.0234C19.6516 66.0234 19.6529 65.4262 19.7331 64.623C19.9547 64.8391 20.1904 65.031 20.4286 65.2025L20.263 66.5038L17.6632 73.9874L9.96171 84.5146C9.8598 84.399 9.77191 84.2744 9.70312 84.1423Z",
    fill: "url(#paint9_linear_7938_60607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.62109 87.1998C8.75484 86.6305 9.24654 85.4906 9.5739 85.1258C9.69364 84.9911 9.83376 84.7573 9.96241 84.5159C9.96241 84.5159 10.2274 84.8043 10.435 84.9543C10.435 84.9543 10.1293 85.1691 9.86815 85.4283C9.65288 85.6431 9.05674 86.985 8.85675 87.4412C8.71408 87.3027 8.62109 87.1998 8.62109 87.1998Z",
    fill: "url(#paint10_linear_7938_60607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.9921 45.2932C53.2214 45.3174 53.3296 45.3733 53.3589 45.4444L53.3678 45.4775C53.3678 45.4775 53.3678 45.4775 53.3678 45.4788C53.3678 45.4775 53.229 45.2945 52.629 45.4673C52.0278 45.6401 51.2278 46.0506 51.1527 46.1548C51.0775 46.259 50.1948 48.5324 50.0649 48.8514C49.9859 49.0408 49.5553 49.2454 49.5553 49.2454C49.5553 49.2454 49.7795 49.746 49.8419 50.018C49.8419 50.018 49.4904 49.3546 49.4114 49.3419C49.4114 49.3419 42.1494 51.0562 42.05 51.0651C41.9494 51.074 36.6325 50.1184 36.0606 50.0421C35.2874 49.9392 34.1562 50.4018 34.1562 50.4018C34.1562 50.4018 34.9931 49.6596 36.1052 49.6927L41.9201 50.5047L48.7503 49.0204C48.7503 49.0204 48.8407 49.0395 48.9031 49.15C48.9031 49.15 49.6037 48.8412 49.6763 48.7625C49.7489 48.6837 50.7132 47.0787 50.8177 46.4102C50.8699 46.2781 50.9196 46.1701 50.9616 46.1027C51.2024 45.7227 52.401 45.2309 52.9921 45.2932Z",
    fill: "url(#paint11_linear_7938_60607)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3041 48.4587C38.3041 48.4587 37.587 48.3405 37.3946 48.2554L36.9883 49.563L37.6468 49.6291L38.3041 48.4587Z",
    fill: "url(#paint12_linear_7938_60607)"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 109,
    height: 109,
    rx: 54.5,
    stroke: "white",
    strokeWidth: 2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7938_60607",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.5817 52.0599) scale(74.8931 74.7152)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42D1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00A6BF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7938_60607",
    x1: -28.9126,
    y1: 111.317,
    x2: 119.99,
    y2: 40.4286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1569,
    stopColor: "#003840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3079,
    stopColor: "#006777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4373,
    stopColor: "#00899E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5401,
    stopColor: "#009EB6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6034,
    stopColor: "#00A6BF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7938_60607",
    x1: 47.5276,
    y1: 74.1404,
    x2: 96.0899,
    y2: 24.5518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2759,
    stopColor: "#00738D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7938_60607",
    x1: 36.8125,
    y1: 53.4355,
    x2: 35.0122,
    y2: 59.5306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1327,
    stopColor: "#071617"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4123,
    stopColor: "#184D53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8122,
    stopColor: "#34A5B3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#42D1E2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7938_60607",
    x1: 41.0563,
    y1: 41.2404,
    x2: 36.3392,
    y2: 42.4696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#1A5158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2F96A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#3DC1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4233,
    stopColor: "#42D1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7004,
    stopColor: "#9BE0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_7938_60607",
    x1: 37.9429,
    y1: 54.5113,
    x2: 17.5755,
    y2: 59.8189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2996,
    stopColor: "#9BE0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5767,
    stopColor: "#42D1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6244,
    stopColor: "#3DC1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2F96A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8546,
    stopColor: "#1A5158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_7938_60607",
    x1: 26.526,
    y1: 65.0375,
    x2: 36.7909,
    y2: 78.2457,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#1A5158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2F96A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#3DC1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4233,
    stopColor: "#42D1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7004,
    stopColor: "#9BE0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_7938_60607",
    x1: 39.5383,
    y1: 42.6066,
    x2: 39.8192,
    y2: 48.9023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFF0B5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2996,
    stopColor: "#9BE0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5767,
    stopColor: "#42D1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6244,
    stopColor: "#3DC1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#2F96A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8546,
    stopColor: "#1A5158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_7938_60607",
    x1: 32.5031,
    y1: 78.2552,
    x2: 32.2763,
    y2: 82.8542,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#1A5158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2F96A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#3DC1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4233,
    stopColor: "#42D1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7004,
    stopColor: "#9BE0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_7938_60607",
    x1: 22.3648,
    y1: 72.6137,
    x2: 7.69954,
    y2: 76.4353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#1A5158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2F96A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#3DC1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4233,
    stopColor: "#42D1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7004,
    stopColor: "#9BE0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_7938_60607",
    x1: 10.357,
    y1: 84.3775,
    x2: 8.62769,
    y2: 87.4512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#1A5158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2F96A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#3DC1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4233,
    stopColor: "#42D1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7004,
    stopColor: "#9BE0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_7938_60607",
    x1: 53.7668,
    y1: 46.9932,
    x2: 34.5764,
    y2: 51.994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1454,
    stopColor: "#1A5158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#2F96A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3756,
    stopColor: "#3DC1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4233,
    stopColor: "#42D1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7004,
    stopColor: "#9BE0CD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFF0B5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_7938_60607",
    x1: 38.0559,
    y1: 47.882,
    x2: 37.1543,
    y2: 49.9705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#42D1E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1128,
    stopColor: "#3DC1D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3386,
    stopColor: "#2F96A2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6565,
    stopColor: "#1A5158"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7938_60607"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 107,
    height: 107,
    rx: 53.5,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConsistancyChamp);
export default __webpack_public_path__ + "static/media/ConsistancyChamp.ee07f2ea0158b05f5137e76b4758b87e.svg";
export { ForwardRef as ReactComponent };